import React, { Component, PropTypes } from 'react';
import { api } from 'OMFECore/webapi';

export default function (TargetClass) {
    return class extends Component {

        static propTypes = {
            children: PropTypes.node,
        };

        constructor(props, context) {
            super(props, context);
            this.uuid = api.createClientRequestId();
        }

        render() {
            const { children, ...restProps } = this.props;
            const newProps = { ...restProps, uuid: this.uuid };
            return (
                <TargetClass {...newProps}>
                    {children}
                </TargetClass>
            );
        }
    };
}



// WEBPACK FOOTER //
// ./src/SharedComponents/uuidWrapper.js